<template>
  <div>
    <b-row>
      <b-col cols="8">
        <div>
          <h2>{{ $t("fuelStockMovement.title") }}</h2>
        </div>
        <div>
          <b-button @click="backToList" size="sm">
            {{ $t("geral.backtolist") }}
          </b-button>
          <router-link
            :to="`/checklist/Layout/form/fill/${$store.getters.formFuelEntraceId}`"
          >
            <b-button class="ml-2" size="sm">
              {{ $t("fuelStockMovement.createEntry") }}
            </b-button>
          </router-link>
          <router-link
            :to="`/checklist/Layout/form/fill/${$store.getters.formFuelSupplyId}`"
          >
            <b-button class="ml-2" size="sm">
              {{ $t("fuelStockMovement.createSupply") }}
            </b-button>
          </router-link>
          <router-link
            :to="`/checklist/Layout/form/fill/${$store.getters.formFuelStockTransferId}`"
          >
            <b-button class="ml-2" size="sm">
              {{ $t("fuelStock.transfer") }}
            </b-button>
          </router-link>
          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="filtersClean"
          >
            {{ $t("geral.cleanFilters") }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="$refs.table.refresh()"
          >
            <i
              class="material-icons"
              style="font-size: 18px; vertical-align: middle; margin-right: 5px"
            >
              refresh
            </i>
            {{ $t("geral.refresh") }}
          </b-button>
        </div>
      </b-col>
      <b-col
        cols="4"
        style="display: flex; justify-content: flex-end; align-items: flex-end"
      >
        <base-event-timer
          :timer.sync="eventTimer"
          :lastRefreshTime="lastRefreshTime"
        ></base-event-timer>
        <!-- {{eventTimer}} -->
      </b-col>
    </b-row>

    <div v-if="isLoadingFilters">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <b-table
        ref="table"
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        current-page="0"
        :filter.sync="tableFilters"
        :filter-debounce="500"
        :responsive="true"
        selectable
        @context-changed="contextChanged"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.key == 'actions'">
                <b-button
                  size="sm"
                  class="btn-checklist cleanFilters"
                  @click="filtersClean"
                >
                  {{ $t("geral.cleanFilters") }}
                </b-button>
              </div>
              <div v-else-if="field.filterType == 'fuelType'">
                <b-form-select
                  id="fuelType"
                  :placeholder="$t('fuelStockMovement.fields.fuelTypeTooltip')"
                  v-model="fuelTypeId"
                  :disabled="true"
                >
                  <option :value="null"></option>
                  <option value="1">
                    {{ $t("fuelStockMovement.fields.fuelTypeDieselComum") }}
                  </option>
                  <option value="5">
                    {{ $t("fuelStockMovement.fields.fuelTypeDieselS10") }}
                  </option>
                  <option value="2">
                    {{ $t("fuelStockMovement.fields.fuelTypeGasolina") }}
                  </option>
                  <option value="3">
                    {{ $t("fuelStockMovement.fields.fuelTypeEtanol") }}
                  </option>
                  <option value="4">
                    {{ $t("fuelStockMovement.fields.fuelTypeArla") }}
                  </option>
                  <option value="6">
                    {{ $t("fuelStockMovement.fields.fuelTypeAVGAS") }}
                  </option>
                </b-form-select>
              </div>
              <div v-else-if="tableFilters[field.key] != null">
                <div v-if="field.filterType == 'dateRange'">
                  <base-filter-date
                    ref="baseFilterDate"
                    :dateFill.sync="tableFilters[field.filterDateEquals]"
                    :dateBegin.sync="tableFilters[field.filterDateBegin]"
                    :dateEnd.sync="tableFilters[field.filterDateEnd]"
                    :filterName.sync="field.label"
                    :optionFilterDate.sync="optionFilterDate"
                    :filterDates="filterDateApplied"
                  ></base-filter-date>
                </div>
                <div v-else-if="field.filterType == 'double'">
                  <b-form-input type="text" v-model="tableFilters[field.key]" />
                </div>
                <div v-else-if="field.filterType == 'movementType'">
                  <b-form-select
                    id="movementType"
                    :placeholder="
                      $t('fuelStockMovement.fields.movementTypeTooltip')
                    "
                    v-model="tableFilters[field.key]"
                    readonly
                  >
                    <option value="">
                      {{ $t("fuelStockMovement.fields.movementTypeAll") }}
                    </option>
                    <option value="E">
                      {{ $t("fuelStockMovement.fields.movementTypeInbound") }}
                    </option>
                    <option value="S">
                      {{ $t("fuelStockMovement.fields.movementTypeOutbound") }}
                    </option>
                  </b-form-select>
                </div>
                <div v-else>
                  <b-form-input
                    v-model="tableFilters[field.filterKey]"
                    :placeholder="'Buscar por ' + field.label"
                    class="idStyle"
                  />
                </div>
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)> </template>
        <template v-slot:cell(checklistId)="data">
          <router-link
            :to="'/checklist/form/filled/details/' + data.item.checklistId"
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
        </template>
      </b-table>
    </div>
    <div>
      <table-pagination-range
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
        @homePage="homePage"
        @prevPage="prevPage"
        @nextPage="nextPage"
      >
      </table-pagination-range>
    </div>
  </div>
</template>

<script>
import TablePaginationRange from "@/components_rms/base/TablePaginationRange.vue";

export default {
  components: {
    TablePaginationRange,
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    BaseEventTimer: () => import("@/components_rms/base/BaseEventTimer.vue"),
  },
  props: {
    fuelTypeId: {
      type: String,
      default: "1",
      description: "ID do tipo de combustível",
    },
    internalGasStation: {
      type: String,
      default: "",
      description: "Posto interno",
    },
  },
  data() {
    return {
      fields: [
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Abastecimento",
          thStyle: "width: 110px",
        },
        {
          key: "fuelType",
          filterKey: "fuelType",
          filterType: "fuelType",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.fuelType"),
          thStyle: "width: 110px",
        },
        {
          key: "internalGasStation",
          filterKey: "internalGasStation",
          filterType: "internalGasStation",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.internalGasStation"),
          thStyle: "width: 180px",
        },
        {
          key: "movementDate",
          filterKey: "date",
          filterType: "dateRange",
          filterDateEquals: "movementDate",
          filterDateBegin: "movementDateBegin",
          filterDateEnd: "movementDateEnd",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.datetimeMoviment"),
          thStyle: "width: 110px",
        },
        {
          key: "movementType",
          filterKey: "movementType",
          filterType: "movementType",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.movementType"),
          thStyle: "width: 110px",
        },
        {
          key: "movementLiters",
          filterKey: "movementLiters",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.movementLiters"),
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "movementValuePerLiter",
          filterKey: "movementValuePerLiter",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.movementValuePerLiter"),
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "stockLiters",
          filterKey: "stockLiters",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.stockLiters"),
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "stockValuePerLiter",
          filterKey: "stockValuePerLiter",
          sortable: false,
          label: this.$t("fuelStockMovement.fields.stockValuePerLiter"),
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        // {
        //   key: "actions",
        //   filterKey: "actions",
        //   sortable: false,
        //   label: "",
        //   thStyle: "width: 110px",
        // },
      ],
      tableFilters: {
        movementType: "",
        movementId: "",
        movementDate: "",
        movementDateBegin: "",
        movementDateEnd: "",
        movementLiters: "",
        movementValuePerLiter: "",
        stockLiters: "",
        stockValuePerLiter: "",
        originChecklistId: "",
      },
      tableItems: [],
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 0,
        eventTimerSeconds: 0,
        pageUrl: "",
      },
      isBusy: false,
      isLoadingFilters: false,
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      optionFilterDate: 0,
      refreshTime: 0,
      timer: null,
      lastRefreshTime: null,
      filterDateApplied: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created() {
    this.myProviderCount();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    backToList() {
      history.back();
    },
    filtersClean() {
      this.tableFilters = {
        movementType: "",
        movementId: "",
        movementDate: "",
        movementDateBegin: "",
        movementDateEnd: "",
        movementLiters: "",
        movementValuePerLiter: "",
        stockLiters: "",
        stockValuePerLiter: "",
        originChecklistId: "",
      };
    },
    init() {
      this.$refs.table.refresh();
    },
    refreshPage() {
      // if (this.eventTimer.eventTimerMiliseconds == 0) return;
      this.timer = setInterval(
        this.init,
        this.eventTimer.eventTimerMiliseconds
      );
    },
    myProvider(ctx, callback) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        callback([]);
      }

      this.lastRefreshTime = new Date();
      this.isBusy = true;
      let apiFilter = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        fuelType: parseInt(this.fuelTypeId),
        internalGasStation: this.internalGasStation,
        movementType: this.tableFilters.movementType,
        movementId: this.tableFilters.movementId,
        movementDateEquals: this.tableFilters.movementDate,
        movementDateBegin: this.tableFilters.movementDateBegin,
        movementDateEnd: this.tableFilters.movementDateEnd,
        movementLiters: this.tableFilters.movementLiters,
        movementValuePerLiter: this.tableFilters.movementValuePerLiter,
        stockLiters: this.tableFilters.stockLiters,
        stockValuePerLiter: this.tableFilters.stockValuePerLiter,
        originChecklistId: this.tableFilters.originChecklistId,
      };
      this.$apiVehicle
        .post("/fuelStockMovement/paginate/list", apiFilter)
        .then((response) => {
          const items = response.data;
          this.isBusy = false;
          this.tableItems = items;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            callback([]);
          }
        });
      return null;
    },
    async myProviderCount() {
      if (this.isLoadingFilters) {
        this.tableRowCount = 0;
      }
      let apiFilter = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        fuelType: parseInt(this.fuelTypeId),
        movementType: this.tableFilters.movementType,
        movementId: this.tableFilters.movementId,
        movementDateEquals: this.tableFilters.movementDate,
        movementDateBegin: this.tableFilters.movementDateBegin,
        movementDateEnd: this.tableFilters.movementDateEnd,
        movementLiters: this.tableFilters.movementLiters,
        movementValuePerLiter: this.tableFilters.movementValuePerLiter,
        stockLiters: this.tableFilters.stockLiters,
        stockValuePerLiter: this.tableFilters.stockValuePerLiter,
        originChecklistId: this.tableFilters.originChecklistId,
      };
      this.$apiVehicle
        .post("/fuelStockMovement/paginate/count", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data;
          // this.refresh();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableRowCount = 0;
          }
        });
    },
    homePage() {
      this.tableCurrentPage = 1;
      this.$refs.table.refresh();
    },
    nextPage() {
      this.tableCurrentPage++;
      this.$refs.table.refresh();
    },
    prevPage() {
      this.tableCurrentPage--;
      this.$refs.table.refresh();
    },
    contextChanged() {
      this.tableCurrentPage = 1;
      this.myProviderCount();
    },
  },
  watch: {
    eventTimer() {
      clearInterval(this.timer);
      this.refreshPage();
    },
  },
};
</script>

<style scoped>
.vertical-align {
  vertical-align: bottom !important;
}
.left {
  margin-left: 0px !important;
}
</style>
